import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=c568ec38&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=c568ec38&lang=scss&scoped=true"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=c568ec38&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c568ec38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c568ec38')) {
      api.createRecord('c568ec38', component.options)
    } else {
      api.reload('c568ec38', component.options)
    }
    module.hot.accept("./ProjectDetail.vue?vue&type=template&id=c568ec38&scoped=true", function () {
      api.rerender('c568ec38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/project/components/ProjectDetail.vue"
export default component.exports